import Axios from "axios"
import QueryString from "qs"

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api"

const api = Axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language":
      localStorage.getItem("i18nextLng") ||
      document.documentElement.lang ||
      "fr",
    Accept: "application/json",
    "App-Identifier": process.env.REACT_APP_IDENTIFIER!,
  },
  paramsSerializer: function (params: any) {
    return QueryString.stringify(params, { arrayFormat: "indices" })
  },
  responseType: "json",
})

api.interceptors.response.use(
  function (response) {
    if (response.config.method?.toLowerCase() !== "get") {
      return response.data
    }
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)
api.interceptors.request.use(
  function (config: any) {
    config.headers = {
      ...config.headers,
      "Accept-Language":
        localStorage.getItem("i18nextLng") ||
        document.documentElement.lang ||
        "fr",
    }
    return config
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)
export default api
